"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSocketServerEndpoint = getSocketServerEndpoint;
/**
 *
 * @deprecated please do not use this, instead use `getEnvVar('REACT_APP_SF_REALTIME_ENDPOINT')`
 */
function getSocketServerEndpoint() {
  console.warn('getSocketServerEndpoint is deprecated and will be removed soon.');
  var NODE_ENV = process.env.NODE_ENV;
  var hostname = (window || {}).location.hostname;
  if (NODE_ENV === 'development' || hostname.includes('localhost')) {
    return process.env.REACT_APP_SF_REALTIME_ENDPOINT;
  }
  if (hostname.includes('cvent-event')) {
    return hostname.replace('app-v4', 'realtime-socket-connector');
  }
  var hostnameArr = hostname.split('.');
  if (hostname.includes('studio') && (hostnameArr[0] === 'studio' || hostnameArr[0] === 'studio-pr50' || hostnameArr[0] === 'studio-dr')) {
    return hostname.replace('studio', 'studio-realtime');
  }
  return hostname.replace('app', 'realtime');
}